






















// Vue
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Mixins} from 'vue-mixin-decorator';

// Components
import Icon, {IconEnum} from '@/shared/components/icon.component.vue';

// Mixins
import ClickOutside from '@/shared/mixins/clickOutside.mixin.ts';


export enum DropdownWidth {
  Max = 'dropdown--max',
  Large = 'dropdown--large',
  Medium = 'dropdown--medium',
}

export enum DropdownStyle {
  Dense = 'dropdown--dense',
  Default = '',
}


@Component({
  components: {
    Icon,
  },
})
export default class Dropdown extends Mixins<ClickOutside>(ClickOutside) {
  @Prop() private data!: any[];
  @Prop() private labelField!: string;
  @Prop() private elementSelected!: any;
  @Prop({default: DropdownWidth.Large}) private dropdownWidth!: DropdownWidth;
  @Prop({default: DropdownStyle.Default}) private DropdownStyle!: DropdownStyle;

  private isOpen: boolean = false;
  private iconEnum = IconEnum;

  private created() {
    this.handleClickOutside();
  }

  get rotationIcon() {
    return (this.isOpen) ? 'rotate_arrow_up' : 'rotate_arrow_down';
  }

  get borderOpen() {
    return (this.isOpen) ? 'element--open' : 'element--close';
  }

  private reduceString(s: string): string {
    if (s.length < 13) {
      return s;
    } else {
      return s.substr(0, 13) + '.';
    }
  }

  private handleClick(element: any) {
    this.toggleOpen();
    this.$emit('input', element);
  }

  private toggleOpen() {
    this.isOpen = !this.isOpen;
  }

  private handleClickOutside() {
    this.clickOutside(() => {
      this.isOpen = false;
    }, 'dropdown');
  }
}
